import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class WildSymbolsFactory extends SymbolsAnimationFactory {
    public getAnimationResource(): string {
        return 'wild'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        if (!symbolData) {
            return null
        }

        if (state === 'land' || state === 'landing' || state === 'win' || state === 'out' || state === 'trigger') {
            return 'animation'
        }

        return 'animation'
    }
}